// Custom jQuery for Envy Shopify Theme, Designed and Coded by Nine (http://www.wearenine.com)

// Shopping Cart jQuery popup

$(document).ready(function () {
    $('.show-shopping-cart').click(function (e) {
        $("#minicart").toggle();
    });

    $('.close-shopping-cart').click(function (e) {
        $('#minicart').toggle();
    });
});

// FlexSlider

$(window).load(function() {
	$('.flexslider').flexslider({
		animation: "slide",
		directionNav: true,
		controlNav: true,
		controlsContainer: ".flexslider-container"
  });
});

// Mobile Browser Menu

$("select#mobile-menu").change(function() {
  window.location = $(this).find("option:selected").val();
});

// Zoom!

$(document).ready(function(){
  $('.featured-image-div').zoom();		
  $('a.image-swap').click(function() {
    var newImage = $(this).attr('href');
    $( '.featured-image-div img' ).attr({ src: newImage }); 
    return false;
  });
  
});    